import {PdfBigPreview, ImageBigPreview} from "components";
import useEmailFilesPreview from "components/EmailFilesPreview/useEmailFilesPreview";
import {Dispatch, SetStateAction} from "react";
import {downloadDocumentFromUrl} from "util/downloadDocumentFromUrl";
import useDownloadFromGuid from "hooks/useDownloadFromGuid";

export interface EmailFilesPreviewProps {
  fileExtension: string;
  fileUrl: string;
  setFileUrl: Dispatch<SetStateAction<string>>;
  fileName: string;
  fileId?: string;
  fileGuid?: string;
}

const EmailFilesPreview = (props: EmailFilesPreviewProps) => {
  const {fileExtension, setFileUrl, fileName, fileUrl, fileId, fileGuid} =
    props;
  const {supportedImagePreview} = useEmailFilesPreview();
  const {handleDownloadFromGuid} = useDownloadFromGuid();

  const handleDownloadFile = async () => {
    if (fileGuid && fileId) {
      await handleDownloadFromGuid(fileGuid, +fileId, fileName);
      return;
    }

    await downloadDocumentFromUrl(fileUrl, fileName);
  };

  const handleDownloadFileAndClosePreview = async () => {
    await handleDownloadFile();
    setFileUrl("");
  };

  return (
    <>
      {fileExtension === "pdf" && (
        <PdfBigPreview
          fileName={fileName}
          fileUrl={fileUrl}
          setFileUrl={setFileUrl}
          showPreview={!!fileUrl}
          handleDownloadFile={handleDownloadFile}
        />
      )}
      {supportedImagePreview.includes(fileExtension) && (
        <ImageBigPreview
          fileUrl={fileUrl}
          setFileUrl={setFileUrl}
          fileName={fileName}
          handleDownloadFileAndClosePreview={handleDownloadFileAndClosePreview}
        />
      )}
    </>
  );
};

export default EmailFilesPreview;
